import { ScrollWrapper } from "@ubnt/store.core/lib/components/ScrollWrapper";
import { BREAKPOINTS } from "layout";
import styled from "styled-components";

export const StyledScrollWrapper = styled(ScrollWrapper)`
  background: transparent;
  display: flex;
  padding: 2px 0;
  width: 100%;

  .scroll-container-item {
    height: 100%;
  }

  > div {
    gap: 12px;
    margin: 0;
  }

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    height: unset;

    > div {
      gap: 12px;
      padding: 0;
    }
  }
`;

export const ButtonWrapper = styled.div`
  min-width: fit-content;
`;
